var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDocumentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.2857V9H14.1428V15.4283H15.4285V12.857H17.3571V11.5713H15.4285V10.2857H18Z",
    fill: "#FF825A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9286 15.4283H8.35718V9H10.9286C11.4399 9.00051 11.9302 9.20385 12.2917 9.5654C12.6533 9.92695 12.8567 10.4172 12.8572 10.9285V13.4998C12.8567 14.0111 12.6533 14.5013 12.2917 14.8629C11.9302 15.2244 11.4399 15.4278 10.9286 15.4283ZM9.64289 14.1426H10.9286C11.099 14.1424 11.2625 14.0747 11.383 13.9541C11.5035 13.8336 11.5713 13.6702 11.5715 13.4998V10.9285C11.5713 10.758 11.5035 10.5946 11.383 10.4741C11.2625 10.3536 11.099 10.2858 10.9286 10.2857H9.64289V14.1426Z",
    fill: "#FF825A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78581 9H2.57153V15.4283H3.85724V13.4998H5.78581C6.12664 13.4993 6.45337 13.3637 6.69438 13.1227C6.93539 12.8817 7.07101 12.555 7.07152 12.2141V10.2857C7.07118 9.94478 6.93561 9.61797 6.69457 9.37693C6.45352 9.1359 6.1267 9.00034 5.78581 9ZM3.85724 12.2141V10.2857H5.78581L5.78645 12.2141H3.85724Z",
    fill: "#FF825A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 7.71414V5.14283C12.8594 5.05835 12.8433 4.97438 12.81 4.8967C12.7767 4.81902 12.727 4.74947 12.6642 4.69285L8.16426 0.193067C8.10766 0.130291 8.03812 0.08054 7.96043 0.0472459C7.88274 0.0139518 7.79875 -0.00209293 7.71426 0.000218587H1.28571C0.945032 0.00123601 0.618597 0.137015 0.3777 0.377902C0.136803 0.618788 0.00101746 0.945208 0 1.28587V16.7137C0 17.0547 0.135458 17.3817 0.376576 17.6228C0.617693 17.8639 0.944719 17.9994 1.28571 17.9994H11.5714V16.7137H1.28571V1.28587H6.42855V5.14283C6.42957 5.4835 6.56535 5.80992 6.80625 6.0508C7.04715 6.29169 7.37358 6.42747 7.71426 6.42848H11.5714V7.71414H12.8571ZM7.71426 5.14283V1.543L11.3142 5.14283H7.71426Z",
    fill: "#FF825A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentPdf);
export default __webpack_public_path__ + "static/media/document-pdf.89a67e70a50f17b48e1a6defb62df66b.svg";
export { ForwardRef as ReactComponent };